import { render, staticRenderFns } from "./FaultCodesWidget.vue?vue&type=template&id=808bd0e6&scoped=true"
import script from "./FaultCodesWidget.vue?vue&type=script&lang=js"
export * from "./FaultCodesWidget.vue?vue&type=script&lang=js"
import style0 from "./FaultCodesWidget.vue?vue&type=style&index=0&id=808bd0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808bd0e6",
  null
  
)

export default component.exports